import {
    BoltDiameter,
    BoltType,
    Material,
    SensorFrequency,
    SensorSize,
} from '../../_generated/api/tagged-hardware'
import Bolt from '../../models/Bolt'
import Sensor from '../../models/Sensor'
import TableControl from '../../models/TableControl'

// Cached array value to avoid creating multiple empty arrays for the sake of declaring array types.
const ARRAY: never[] = []

export const unpackManufacturedBoltsTableSpec = (table: TableControl<Bolt>) =>
    table.unpack({
        createdAt: ARRAY as Date[],
        nominalLength: ARRAY as number[],
        diameter: ARRAY as BoltDiameter[],
        material: ARRAY as Material[],
        type: ARRAY as BoltType[],
    })

export const unpackUnassignedBoltsTableSpec = (table: TableControl<Bolt>) =>
    table.unpack({
        createdAt: ARRAY as Date[],
        nominalLength: ARRAY as number[],
        diameter: ARRAY as BoltDiameter[],
        material: ARRAY as Material[],
        type: ARRAY as BoltType[],
    })

export const unpackBoltConnectionBoltsTableSpec = (table: TableControl<Bolt>) =>
    table.unpack({
        createdAt: ARRAY as Date[],
        nominalLength: ARRAY as number[],
        diameter: ARRAY as BoltDiameter[],
        material: ARRAY as Material[],
        type: ARRAY as BoltType[],
    })

export const unpackAllSensorsTableSpec = (table: TableControl<Sensor>) =>
    table.unpack({
        size: ARRAY as SensorSize[],
        frequency: ARRAY as SensorFrequency[],
    })
